import { connect } from "react-redux";
import AddConfig from "./addConfig";
import { bindActionCreators } from "redux";
import { userdropdown, approverdropdown, saveUserConfiguration, updateUserConfig, getUserData } from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    userdropdownlist : state.UserHelpdesk.userdropdown,
    approverdropdownlist : state.UserHelpdesk.approverdropdown,
    updateuserconfiglist : state.UserHelpdesk.updateuserconfig,
    getautofilldatalist : state.UserHelpdesk.getautofilldata
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userdropdown,
        approverdropdown,
        saveUserConfiguration,
        updateUserConfig,
        getUserData,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddConfig);